import constipationQuestions from './Constipation/questions';
import hemorrhoidQuestions from './Hemorrhoids & Anal Fissures/questions';
import pruritusAniQuestions from './pruritusAni/questions';
import lichenSclerosusQuestions from './LichenSclerosus/questions';

const rectalHealthQuestions = [
  ...constipationQuestions,
  ...pruritusAniQuestions,
  ...hemorrhoidQuestions,
  ...lichenSclerosusQuestions
];
export default rectalHealthQuestions;
